import type { RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw[] = [
  {
    name: "exit",
    path: "/exit",
    component: () => import("@/views/flow/ExitView.vue"),
    meta: {
      exitTrigger: false,
      preventBack: true,
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "start.default",
    path: "/start",
    component: () => import("@/views/flow/StartView.vue"),
    meta: {
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "start.entity-key",
    path: "/start/entity-keys/:entityKey",
    component: () => import("@/views/flow/StartView.vue"),
    meta: {
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "start.token",
    path: "/start/tokens/:token",
    component: () => import("@/views/flow/StartView.vue"),
    meta: {
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "start.token.embedded",
    path: "/start/tokens/:token/embedded",
    component: () => import("@/views/flow/StartView.vue"),
    meta: {
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "session.restore",
    path: "/session/restore",
    component: () => import("@/views/flow/RestoreView.vue"),
    meta: {
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "switch.provider-start",
    path: ":providerKey/:applyMode/switch",
    component: () => import("@/views/flow/SwitchProviderView.vue"),
    props: true,
    meta: {
      hideStepper: true,
    },
  },
]

export default routes
